import $ from 'jquery';
import AOS from 'aos/dist/aos';


export default () => {
    AOS.init({
        startEvent: 'load',
        easing: 'ease-out',
        once: true
    });
};



// WEBPACK FOOTER //
// ./scripts/libs/aos.js